import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { plattsburghConfig } from "./data";

export default function PlattsburghPage() {
  return <CityPageTemplate config={plattsburghConfig} />;
}